module.exports = __webpack_public_path__ + "img/图片13.1bf5d28a.png";